import React, { Component } from 'react'
import { message, Button, Input, Form, Upload, Select } from 'antd';
import { uploadMutipleFile } from '../../actions/app'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { Firebase, FirebaseRef } from '../../lib/firebase'
import { updateMember } from './../../actions/member'
import { connect } from "react-redux"
import serviceMail from '../../services/sendmail'

const { Option } = Select;
const DEFAULT_USE = {
  address: "",
  job: "",
  phone: "",
  relation: 'mother',
}
class CircleDetail extends Component {
  constructor(props) {
    super(props)

    let newData = {}
    if (props.location && props.location.state && props.location.state.data) {
      newData = props.location.state.data
    }
    this.state = {
      refresh: true,
      loadingImage: false,

      data: {
        ...DEFAULT_USE,
        ...newData
      },
      imgUrl: newData.imgUrl || ''
    }
    this.id = props.match.params.id || "add"
  }

  getUserData(email) {
    return new Promise(resolve => {
      const ref = FirebaseRef.child('/users').orderByChild('email').equalTo(email)
      ref.once('value', (snapshot) => {
        const data = snapshot.val() || {}

        if (Object.keys(data).length) {
          return resolve({ isExist: true, userDetail: data })
        }
        return resolve({ isExist: false, })
      })
    })
  }

  handleSubmit(values) {
    const { member, history } = this.props
    const { imgUrl } = this.state
    if (this.id === 'add') {
      this.getUserData(values.email).then(result => {

        const { isExist, userDetail } = result
        if (isExist) {
          Object.keys(userDetail).forEach(index => {
            const newUser = this.handleUpdateMember(userDetail[index].uid)
            values.parentId = member.uid
            values.uid = userDetail[index].uid
            values.imgUrl = imgUrl
            if (userDetail[index].groupIds && userDetail[index].groupIds.length) {
              const indexCheck = userDetail[index].groupIds.findIndex(item => item === member.uid)
              if (indexCheck === -1) {
                const newData = [
                  member.uid,
                  ...newUser.groupIds,
                  ...userDetail[index].groupIds
                ]
                console.log(newData, 131)
                userDetail[index].groupIds = [...new Set(newData)]
              } else {
                const newData = [
                  member.uid,
                  ...newUser.groupIds
                ]
                console.log(newData, 122)
                userDetail[index].groupIds = [...new Set(newData)]
              }
            } else {
              const newData = [
                member.uid,
                ...newUser.groupIds
              ]
              console.log(newData, 1242)
              userDetail[index].groupIds = [...new Set(newData)]
            }


            FirebaseRef.child(`users/${userDetail[index].uid}`).set({
              ...userDetail[index],
              ...values
            })
            message.success("Create user successfully!")
            history.push('/manage/circle-user')
          })

        } else {
          Firebase.auth().createUserWithEmailAndPassword(values.email, values.password)
            .then((res) => {
              if (res && res.user.uid) {
                values.parentId = member.uid
                values.uid = res.user.uid
                const newUser = this.handleUpdateMember(res.user.uid)
                values.role = 'user'
                values.imgUrl = imgUrl
                values.password = ""
                values.confirm = ""
                values.groupIds = [...new Set([
                  member.uid,
                  ...newUser.groupIds
                ])]
                values.followIds = []

                FirebaseRef.child(`users/${res.user.uid}`).set(values)
                const email = values.email
                const subject = `Genc Health account infomation.`
                const content = `<div>Username: ${values.email}</div><div> Password: ${values.password}</div>`

                this.handleSendMail(subject, content, 'support@angelo.network', email)
                message.success("Create user successfully!")
                history.push('/manage/circle-user')
              } else {
                message.error("Something was wrong!")
              }
            })
        }
      })

    } else {
      const { data } = this.state
      values.imgUrl = imgUrl
      const newUser = this.handleUpdateMember(this.id)
      if (data.groupIds && Array.isArray(data)) {

        const indexCheck = data.groupIds.findIndex(item => item === member.uid)
        if (indexCheck === -1) {
          const newData = [
            member.uid,
            ...newUser.groupIds,
            ...data.groupIds
          ]
          console.log(newData)
          data.groupIds = [...new Set(newData)]
        } else {
          const newData = [
            member.uid,
            ...newUser.groupIds,

          ]
          console.log(newData)
          data.groupIds = [...new Set(newData)]
        }
      } else {
        const newData = [
          member.uid,
          ...newUser.groupIds,

        ]
        console.log(newData)
        data.groupIds = [...new Set(newData)]
      }

      FirebaseRef.child(`users/${this.id}`).set({
        ...data,
        ...values
      })
      message.success("Update user successfully!")
      history.push('/manage/circle-user')
    }

  }

  handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message
    }
    serviceMail.sendMail(data).then(() => {
    })
  }

  beforeUpload(file) {

    const isLt4M = file.size / 1024 / 1024 < 4
    if (!isLt4M) {
      message.error('Image must smaller than 4MB!')
    }
    return isLt4M
  }

  handleUploadImage(file) {
    uploadMutipleFile(file, `${file.uid}/app/img`).then(result => {
      const { url, isSuccess } = result

      if (isSuccess) {
        this.setState({
          imgUrl: url
        })
      }
    })
  }

  handleChangeImage = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loadingImage: true })
      return
    }
    if (info.file.status === 'done' || info.file.status === 'error') {
      // Get this url from response in real world.
      this.handleUploadImage(info.file.originFileObj)
      this.getBase64(info.file.originFileObj, _ => this.setState({
        loadingImage: false,
      }
      ))
    }
  };

  getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  handleUpdateMember(id) {
    const { member, updateMember } = this.props

    if (member.groupIds && Array.isArray(member.groupIds)) {
      const index = member.groupIds.findIndex(key => key === id)
      if (index === -1) {
        member.groupIds.push(id)
      }

    } else {
      member.groupIds = [id]

    }


    updateMember(member.uid, member)
    return member
  }

  render() {
    const { imgUrl, loadingImage, data, refresh } = this.state
    const uploadButton = (
      <div>
        {
          loadingImage ? (<LoadingOutlined></LoadingOutlined>) : (<PlusOutlined></PlusOutlined>)
        }

        <div className="ant-upload-text">Drop an image here.</div>
      </div>
    )

    if (!refresh) {
      return <></>
    }
    return (
      <Form initialValues={data} layout="vertical" onFinish={(values) => { this.handleSubmit(values) }}>

        <div className="row">

          <div className="col-12 col-md-6">

            <Form.Item
              label="Avatar"
              className={this.id === 'add' ? 'circle__img' : 'circle__img-2'}
            >
              <Upload

                name="imgUrl"
                listType="picture-card"

                showUploadList={false}
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={(file) => { this.beforeUpload(file) }}
                onChange={(info) => { this.handleChangeImage(info) }}
              >
                {imgUrl ? <img src={imgUrl} style={{ maxHeight: '550px' }} alt="avatar" /> : uploadButton}
              </Upload>
            </Form.Item>




          </div>
          <div className="col-12 col-md-6">
            <Form.Item
              name="email" rules={
                [
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                  {
                    required: true,
                    message: 'Please input your E-mail!',
                  },
                ]} label="Email">
              <Input onBlur={(e) => {
                if (this.props.match.params.id === "add") {
                  const { value } = e.target
                  const { data } = this.state
                  const that = this
                  this.getUserData(value).then(result => {
                    const { isExist, userDetail } = result

                    if (isExist) {
                      Object.keys(userDetail).forEach(key => {
                        that.setState({
                          data: userDetail[key],
                          imgUrl: userDetail[key].imgUrl || imgUrl,
                          refresh: false
                        }, () => {
                          this.id = userDetail[key].uid
                          that.setState({
                            refresh: true
                          })

                        })

                      })
                    } else {

                      that.setState({
                        data: {
                          ...data,
                          email: value,
                          password: null,
                          confirm: null
                        },
                        refresh: false
                      }, () => {
                        this.id = "add"
                        that.setState({
                          refresh: true
                        })

                      })
                    }
                  })
                }

              }} size="large"
              />
            </Form.Item>
            <Form.Item
              name="nickname" rules={
                [{ required: true, message: 'Please input your nickname!', whitespace: true }]
              }
              label={
                "Nickname"
              }
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              name="phone"
              label={
                "Phone number"
              }
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              name="address"
              label={
                "Your address"
              }
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="job"
              label={
                "Your job"
              }
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="relation"
              label={
                "Relationship"
              }
            >
              <Select name="relation" style={{ width: '100%' }} >
                <Option value="mother">Mother</Option>
                <Option value="father">Father</Option>
                <Option value="brother">Brother</Option>
                <Option value="son">Son</Option>
                <Option value="daughter">Daughter</Option>
                <Option value="another">Another</Option>
                <Option value="Mother in law">Mother in law</Option>
                <Option value="Son in law">Son in law</Option>
                <Option value="Daughter in law">Daughter in law</Option>
                <Option value="Brother in law">Brother in law</Option>
                <Option value="Sister in law">Sister in law</Option>
              </Select>
            </Form.Item>
            {
              this.id === 'add' ? (
                <>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                    hasFeedback
                  >
                    <Input.Password autoComplete="new-password" size="large" />
                  </Form.Item>

                  <Form.Item
                    name="confirm"
                    label="Confirm Password"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Please confirm your password!',
                      },
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject('The two passwords that you entered do not match!');
                        },
                      }),
                    ]}
                  >
                    <Input.Password autoComplete="new-password" size="large" />
                  </Form.Item>
                </>
              ) : null
            }
            <Form.Item style={{ textAlign: 'right' }} >
              <Button type="primary" htmlType="submit">
                Save
                 </Button>
            </Form.Item>
          </div>
        </div>



      </Form>
    )
  }
}

const mapStateToProps = state => ({
  member: state.member || {},
});

const mapDispatchToProps = dispatch => {
  return {
    updateMember: (id, data) => updateMember(id, data)
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CircleDetail)
